import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import App from './App';
import LoginPanel from './components/LoginPanel';
import Home from './components/Home';
import Project from './components/project/Project';
import ProjectHome from './components/project/ProjectHome';
import Board from './components/board/Board';
import StateDiagramController from './components/diagram/StateDiagramController';
import Settings from './components/projectSettings/ProjectSettings';
import Plugins from './components/plugins/Plugins';
import Analytics from './components/analytics/Analytics';
import Webhooks from "./components/webhooks/Webhooks";
import Material from "./components/material/Material";
import './index.css';

ReactDOM.render(
    <Router history={browserHistory}>
        <Route path="/" component={App}>
            <IndexRoute component={Home} />
            <Route path="material" component={Material} />
            <Route path="login" mode={LoginPanel.Modes.Login} component={LoginPanel} />
            <Route path="register" mode={LoginPanel.Modes.Register} component={LoginPanel} />
            <Route path="forgotPassword" mode={LoginPanel.Modes.ForgotPassword} component={LoginPanel} />
            <Route path="resetPassword(/:resetPasswordToken)" mode={LoginPanel.Modes.ResetPassword} component={LoginPanel} />
            <Route path="projects/:projectId" component={Project}>
                <IndexRoute component={ProjectHome}/>
                <Route path="settings" component={Settings}/>
                <Route path="workflow" component={StateDiagramController}/>
                <Route path="plugins" component={Plugins}/>
                <Route path="analytics" component={Analytics}/>
                <Route path="webhooks" component={Webhooks}/>
                <Route path="boards/:boardId" component={Board}/>
            </Route>
        </Route>
    </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js